// Given a File generate/get a Base64 string out of it.
export function getBase64(file: File, base64ContentOnly?: boolean) {
  return new Promise<Base64>((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      if (base64ContentOnly) {
        return resolve(String(reader.result).split('base64,')[1]);
      }
      return resolve(reader.result as Base64);
    };
    reader.onerror = (error) => reject(error);
  });
}
